export default __webpack_public_path__ + "assets/images/471c6aabf9afda700da6445f59366d9d.png";